import { render, staticRenderFns } from "./RefundArticlesFees.vue?vue&type=template&id=a9e52a7c&scoped=true"
import script from "./RefundArticlesFees.vue?vue&type=script&lang=js"
export * from "./RefundArticlesFees.vue?vue&type=script&lang=js"
import style0 from "./RefundArticlesFees.vue?vue&type=style&index=0&id=a9e52a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e52a7c",
  null
  
)

export default component.exports